import emailSuggestion from '#shared/util/emailSuggestion.js';

import cFormLine from '#themes/default/default/components/formLine/formLine.js';
import cInput from '#themes/default/default/components/input/input.js';

import template from './formInput.html';

export default {
	name: 'CFormInput',
	components: {
		cFormLine,
		cInput
	},
	props: {
		customer: {
			type: Object,
			default: () => null
		},
		customClass: {
			type: String,
			default: ''
		},
		errorMessage: {
			type: String,
			default: ''
		},
		form: {
			type: Object,
			default: () => null
		},
		isDisabled: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		note: {
			type: String,
			default: ''
		},
		order: {
			type: Object,
			default: () => null
		},
		paymentType: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: null
		},
		reference: {
			type: String,
			required: true
		},
		size: {
			type: String,
			default: 'large'
		},
		theme: {
			type: Object,
			default: () => null
		},
		type: {
			type: String,
			default: 'string'
		},
		url: {
			type: Object,
			default: () => null
		},
		value: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			suggestions: {},
			lastEmail: '',
			activePlaceholder: null,
			isActiveInput: false
		};
	},
	computed: {
		inputValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			}
		},
		isTaxField() {
			return this.type === 'tax';
		},
		isEmailField() {
			return this.type === 'email';
		},
		hasError() {
			return this.$refs[this.reference]?.hasError;
		},
		className() {
			const identifierClass = `${this.reference}${this.paymentType}`;
			return {
				input: this.customClass,
				test: `t-${this.reference}Input`,
				identifier: identifierClass,
				error: `${identifierClass}_error`
			};
		}
	},
	methods: {
		async getEmailSuggestion(eventTarget, displayEmailNote = false, checkDomain = true) {
			await this.$nextTick();
			this.suggestions = await emailSuggestion(eventTarget, displayEmailNote, checkDomain, this.lastEmail, this.customer.billing.email, this.suggestions, {
				order: this.order
			});
			if (checkDomain) {
				this.lastEmail = this.customer.billing.email;
			}
		}
	},
	template
};
